document.addEventListener('DOMContentLoaded', () => {
	// eslint-disable-next-line
	const masonry = new Isotope('.block--portfolio__gallery', {
		itemSelector: '.gallery-item',
		layoutMode: 'masonry',
		masonry: {
			columnWidth: '.gallery-sizer',
			gutter: 16,
		},
	});
});
